import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const MarkAsSpamModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "MarkAsSpamModalContainer" */
      './MarkAsSpamModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
